
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1> Chess Championship </h1>
				</div>
			</div>
		</div>
	</div>
	<div class="breadcrumb-bottom-img">
		<img
			src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
	</div>
</section>
<section class="section section-sm fide-chesscompetition section-banner-bg-1">
	<div class="container">
		<div class="sec-title text-center">
			<h2> Maharastra State Under 09 Open & Girls <span> Selection Chess
					Championship 2023 </span></h2>
		</div>
		<div class="row">
			<div class="col-md-8">
				<div class="fide-chess-text">
					<p class="text-justify">
						Vivan Kasliwal (unrated player ) of Nashik in Open Group and Tvesha Ashish
						Jain of Mumbai City
						in Girls Group win annex the Maharashtra State Under-9 Open and Girls
						Selection Chess
						Championship. The Championship was
						organised by Chess Association Nagpur in association with the G.H.Raisoni
						Sports and Cultural
						Foundation and Kalpana Prakash Welfare Foundation at G.H.Raisoni Institute
						of Engineering and
						Technology, Shraddha Park,
						Wadi Hingna Link Road, Nagpur.
					</p>
					<p class="text-justify">
						Earlier Inaugration of the Championship was done by the hands of Hon.Ex
						MLA Shri Girish Vyas
						Vice President, Maharashtra Chess Association Grandmaster Sankalp Gupta,
						Shri Ankush Raktade Jt.
						Secretary, Maharashtra
						Chess Association Dr. Mrunal Naik Project Head Raisoni Group Nagpur
					</p>
					<p class="text-justify">Vivan scored 6.5 points out of 8 rounds in Open
						Group with better tie break
						score whereas Tvesha scored 7.5 points out of 8 rounds in Girls group.</p>

					<p class="text-justify">
						Nagpur kids Chirag Lahoti and Arav Dhoot had sensational event, both also
						scored 6.5 points and
						were adjudged Second and Third respectively according to their Tie Break
						Score. R. Mithun of
						Raigad too scored 6.5
						point and was placed fourth on merit list based on tie break score.
					</p>
				</div>
			</div>

			<div class="col-md-4">
				<iframe
					src="https://drive.google.com/file/d/1ajQpBjG0rmS91h6o2XXQSbo2mOUe6F2v/preview"
					width="100%"
					height="500px" frameborder="0"></iframe>
			</div>
			<div class="col-md-12">
				<p class="text-justify">
					In the girls group, 2 nd Seed Tvesha Jain with 7.5 points pipped Top seed
					Bhumika Waghale of
					Aurangabad to win the championship. Bhumika was placed second with 7
					points. Narayani Marathe of
					Nandurbar, Ananya Roy of
					Mumbai Sub urban District and Vishwaja Deshmukh of Nagpur scored 6 points
					and were placed 3 rd to 5
					th in the Girls merit list as per their progressive score.
				</p>
				<p class="text-justify">Vivan Kasliwal and Chirag Lahoti shall represent
					Maharashtra in National Under-9
					Chess Championship in Open Group while Tvesha Jain and Bhumika Waghale will
					represent Maharashtra in
					Girls Group.</p>
				<p class="text-justify">
					Prizes were distributed at the hands of Adv Nishant Gandhi, Chairman of
					Organising Committee of the
					Event in presense of Shri Bhushan Shriwas, Secretary, Chess Association
					Nagpur. . Program was
					compered by Shri S.S.Soman
					who also proposed vote of thanks.
				</p>
				<p class="text-justify">
					IA Deepak Chavan was the Chief Arbiter of the Championship who was assisted
					by Dy Chief Arbiter FA
					Shiva Iyer, FA Swati Kumbhalkar, FA Amit Tembhurne, SNA Shyam Agrawal, SNA
					Sagar Sakhare, SNA Prayas
					Ambade, Prathamesh
					Machave and Shirshir Indurkar.
				</p>
				<p>chess result link :</p>

				<p><a href="https://www.rediff.com/" target="_blank">Open :
						https://chess-results.com/tnr750788.aspx?lan=1&art=1&rd=8</a></p>

				<p><a href="https://www.rediff.com/" target="_blank">Girls :
						https://chess-results.com/tnr750792.aspx?lan=1&art=1&rd=8</a></p>

				<p>
					<strong>IA Deepak Chavan</strong>
					<br />
					<strong>Chief Arbiter</strong>
					<br />
					<strong>Maharashtra State Under-9 Open and Girls Selection Chess
						Championship</strong>
				</p>
			</div>
			<div class="col-md-6">
				<iframe
					src="https://drive.google.com/file/d/1tysZ3X6jq-CFoFiYml8GY2Hjy_y2aNKt/preview"
					width="100%"
					height="600px" frameborder="0"></iframe>
			</div>
			<div class="col-md-6">
				<iframe
					src="https://drive.google.com/file/d/1pSHsctf9EFqvuYVRNHz4w0oumchc9Ly1/preview"
					width="100%"
					height="600px" frameborder="0"></iframe>
			</div>
		</div>
	</div>
</section>
<section class="section section-sm fide-chesscompetition section-banner-bg-1">
	<div class="container">
		<div class="border-line-sm"></div>
		<div class="row row-cols-1 row-cols-md-2">

			<div class="col">
				<div class="gall-ery">
					<div class="row">
						<div class="widget_title inner-title gall-sys shadow-text-sm">
							<h4 class="fw-bold">Media Coverage</h4>
						</div>
						<div class="lightBox--gallery">
							<ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-3">
								<li class="col"
									data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-camp1.webp"
									data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-camp1.webp">
									<a href="Javascript:void(0);">
										<img
											src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-camp1.webp"
											alt="GHRSCF" title="GHRSCF" class="img-fluid" />
										<div class="light-gallery-poster">
											<img
												src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
										</div>
									</a>
								</li>
								<li class="col"
									data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-camp2.webp"
									data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-camp2.webp">
									<a href="Javascript:void(0);">
										<img
											src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-camp2.webp"
											alt="GHRSCF" title="GHRSCF" class="img-fluid" />
										<div class="light-gallery-poster">
											<img
												src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
										</div>
									</a>
								</li>
								<li class="col"
									data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-camp3.webp"
									data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-camp3.webp">
									<a href="Javascript:void(0);">
										<img
											src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-camp3.webp"
											alt="GHRSCF" title="GHRSCF" class="img-fluid" />
										<div class="light-gallery-poster">
											<img
												src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
										</div>
									</a>
								</li>
								<li class="col"
									data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-camp4.webp"
									data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-camp4.webp">
									<a href="Javascript:void(0);">
										<img
											src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-camp4.webp"
											alt="GHRSCF" title="GHRSCF" class="img-fluid" />
										<div class="light-gallery-poster">
											<img
												src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
										</div>
									</a>
								</li>
								<li class="col"
									data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-camp5.webp"
									data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-camp5.webp">
									<a href="Javascript:void(0);">
										<img
											src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-camp5.webp"
											alt="GHRSCF" title="GHRSCF" class="img-fluid" />
										<div class="light-gallery-poster">
											<img
												src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
										</div>
									</a>
								</li>
								<li class="col"
									data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-camp6.webp"
									data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-camp6.webp">
									<a href="Javascript:void(0);">
										<img
											src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-camp6.webp"
											alt="GHRSCF" title="GHRSCF" class="img-fluid" />
										<div class="light-gallery-poster">
											<img
												src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
										</div>
									</a>
								</li>
								<li class="col"
									data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-camp7.webp"
									data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-camp7.webp">
									<a href="Javascript:void(0);">
										<img
											src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-camp7.webp"
											alt="GHRSCF" title="GHRSCF" class="img-fluid" />
										<div class="light-gallery-poster">
											<img
												src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
										</div>
									</a>
								</li>
								<li class="col"
									data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-camp8.webp"
									data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-camp8.webp">
									<a href="Javascript:void(0);">
										<img
											src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-camp8.webp"
											alt="GHRSCF" title="GHRSCF" class="img-fluid" />
										<div class="light-gallery-poster">
											<img
												src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
										</div>
									</a>
								</li>
								<li class="col"
									data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-camp9.webp"
									data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-camp9.webp">
									<a href="Javascript:void(0);">
										<img
											src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-camp9.webp"
											alt="GHRSCF" title="GHRSCF" class="img-fluid" />
										<div class="light-gallery-poster">
											<img
												src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
										</div>
									</a>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>

			<div class="col">
				<div class="gall-ery">
					<div class="row">
						<div class="col-md-7">
							<div class="widget_title inner-title gall-sys shadow-text-sm">
								<h4 class="fw-bold">Photos</h4>
							</div>
						</div>
					</div>
					<div class="lightBox--gallery">
						<ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-3">
							<li class="col"
								data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-camp10.webp"
								data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-camp10.webp">
								<a href="Javascript:void(0);">
									<img
										src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-camp10.webp"
										alt="GHRSCF" title="GHRSCF" class="img-fluid" />
									<div class="light-gallery-poster">
										<img
											src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
									</div>
								</a>
							</li>
							<li class="col"
								data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-camp11.webp"
								data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-camp11.webp">
								<a href="Javascript:void(0);">
									<img
										src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-camp11.webp"
										alt="GHRSCF" title="GHRSCF" class="img-fluid" />
									<div class="light-gallery-poster">
										<img
											src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
									</div>
								</a>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
